<script setup lang="ts">
import { AccordionContent, type AccordionContentProps } from 'radix-vue'
import { cn } from '../../../lib/utils';

const props = defineProps<AccordionContentProps & { class?: string }>()
</script>

<template>
  <!-- [html-validate-disable-next prefer-native-element] -->
  <AccordionContent
    v-bind="props"
    :class="
      cn(
        'c-accordion__content overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
        props.class,
      )
    "
  >
    <div class="c-accordion__content__inner">
      <slot />
    </div>
  </AccordionContent>
</template>

<style scoped>
.c-accordion__content__inner {
  /* Here we use gap since we add (padding-gap) to the item */
  padding-bottom: var(--c-accordion-vertical-gap);
  text-align: left;
}
</style>
